(() => {
  if (window.pmcFooterDisclosureBound) return;
  window.pmcFooterDisclosureBound = true;
  document.documentElement.setAttribute("data-pmc-footer-disclosure", "ready");

  const MOBILE_QUERY = "(max-width: 576px)";
  const ROOT_SELECTOR = "[data-pmc-footer-root]";
  const DETAILS_SELECTOR = ".pmc-mobile-footer__details";

  class PmcFooterDisclosureController {
    constructor(root) {
      this.root = root;
      this.details = Array.from(root.querySelectorAll(DETAILS_SELECTOR));
      this.mobileQuery = window.matchMedia(MOBILE_QUERY);
      this.mobileStates = this.details.map(() => false);
      this.mode = null;
      this.onMediaChange = this.sync.bind(this);
      this.onToggle = this.handleToggle.bind(this);
      this.onSummaryClick = this.handleSummaryClick.bind(this);

      this.details.forEach((details) => {
        details.addEventListener("toggle", this.onToggle);
        details
          .querySelector("summary")
          ?.addEventListener("click", this.onSummaryClick);
      });
      this.mobileQuery.addEventListener("change", this.onMediaChange);
      this.sync();
    }

    handleSummaryClick(event) {
      if (!this.mobileQuery.matches) event.preventDefault();
    }

    handleToggle(event) {
      const index = this.details.indexOf(event.currentTarget);
      if (index < 0) return;

      if (this.mobileQuery.matches) {
        this.mobileStates[index] = event.currentTarget.open;
      } else if (!event.currentTarget.open) {
        event.currentTarget.open = true;
      }
    }

    sync() {
      const nextMode = this.mobileQuery.matches ? "mobile" : "desktop";
      if (nextMode === this.mode) return;

      if (this.mode === "mobile") {
        this.mobileStates = this.details.map((details) => details.open);
      }

      this.details.forEach((details, index) => {
        const summary = details.querySelector("summary");
        if (nextMode === "mobile") {
          summary?.removeAttribute("aria-hidden");
          summary?.removeAttribute("tabindex");
          details.open =
            this.mode === null ? false : Boolean(this.mobileStates[index]);
        } else {
          details.open = true;
          summary?.setAttribute("aria-hidden", "true");
          summary?.setAttribute("tabindex", "-1");
        }
      });

      this.mode = nextMode;
    }

    openForBlock(blockElement) {
      const details = blockElement?.closest(DETAILS_SELECTOR);
      if (!details) return;
      details.open = true;
      const index = this.details.indexOf(details);
      if (index >= 0) this.mobileStates[index] = true;
    }

    destroy() {
      this.details.forEach((details) => {
        details.removeEventListener("toggle", this.onToggle);
        details
          .querySelector("summary")
          ?.removeEventListener("click", this.onSummaryClick);
      });
      this.mobileQuery.removeEventListener("change", this.onMediaChange);
    }
  }

  const controllers = new WeakMap();

  const initialize = (scope = document) => {
    const roots = scope.matches?.(ROOT_SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(ROOT_SELECTOR) || []);

    roots.forEach((root) => {
      if (!controllers.has(root))
        controllers.set(root, new PmcFooterDisclosureController(root));
    });
  };

  initialize();

  document.addEventListener("shopify:section:load", (event) =>
    initialize(event.target),
  );
  document.addEventListener("shopify:section:unload", (event) => {
    const roots = event.target.matches?.(ROOT_SELECTOR)
      ? [event.target]
      : Array.from(event.target.querySelectorAll?.(ROOT_SELECTOR) || []);
    roots.forEach((root) => {
      controllers.get(root)?.destroy();
      controllers.delete(root);
    });
  });
  document.addEventListener("shopify:block:select", (event) => {
    const root = event.target.closest?.(ROOT_SELECTOR);
    if (!root) return;
    initialize(root);
    controllers.get(root)?.openForBlock(event.target);
  });
})();
